import axios from "axios";

export const nearestWhereami = async () => {
    try {

        const response = await axios.post("/api/nearest");

        console.log(
            "Detected IP:",
            response.data?.requestInfo?.remoteAddress
        );

        console.log(
            "Forwarded IPs:",
            response.data?.requestInfo?.xForwardedFor
        );

        console.log(
            "nearestWhereami Response:",
            response.data
        );

        // return response.data;
        return response.data.locationResponse;
    } catch (error) {
        console.error(
            "nearestWhereami Error:",
            error
        );
        throw error;
    }
};